import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../styles/navbar.css";
import logo from "../assets/img/logo.jpg";
import fr from "../assets/icons/France.svg";
import en from "../assets/icons/us.svg";

function NavScrollExample() {
  const { t, i18n } = useTranslation();

  const handleChangeLng = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
  };

  return (
    <Navbar expand="lg" className="navbar" sticky="top">
      <Container fluid className="px-4 lg:px-8">
        {/* Logo */}
        <Navbar.Brand href="/" className="navbar-brand-custom">
          <img src={logo} alt="GS7S logo" className="logo" />
        </Navbar.Brand>

        {/* Hamburger mobile */}
        <Navbar.Toggle aria-controls="navbarScroll" className="navbar-toggle-custom" />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="navbar-link mx-auto" navbarScroll>
            <Nav.Link href="/" className="link">
              {t("Accueil")}
            </Nav.Link>

            <NavDropdown title={t("L'entreprise")} id="drop-entreprise" className="link custom-link">
              <NavDropdown.Item href="/entreprise">{t("L'entreprise")}</NavDropdown.Item>
              <NavDropdown.Item href="/entreprise/historique">{t("Historique de la société GS7S")}</NavDropdown.Item>
              <NavDropdown.Item href="/entreprise/nos-metiers">{t("Nos métiers")}</NavDropdown.Item>
              <NavDropdown.Item href="/entreprise/notre-demarche">{t("Notre démarche")}</NavDropdown.Item>
              <NavDropdown.Item href="/entreprise/equipe">{t("L'équipe")}</NavDropdown.Item>
              <NavDropdown.Item href="/entreprise/organigramme">{t("Organigramme")}</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title={t("Domaines")} id="drop-domaines" className="link">
              <NavDropdown.Item href="/domaines">{t("Domaines")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/analyse-strategique-securitaire">{t("Relations Internationales – Sécurité – Maintien de la paix – Stratégies")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/organisation">{t("Organisation et réforme du secteur de la sécurité")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/ressources-humaines">{t("Ressources Humaines")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/enforcement-des-competence">{t("Leadership")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/finances">{t("Finances/Budget")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/logistique-equipements">{t("Logistique/Équipements")}</NavDropdown.Item>
              <NavDropdown.Item href="/domaines/informatique">{t("Informatique")}</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link href="/activites" className="link">{t("Activités")}</Nav.Link>
            <Nav.Link href="/cibles-partenaires" className="link">{t("Cibles et Partenaires")}</Nav.Link>
            <Nav.Link href="/publications" className="link">{t("Publications")}</Nav.Link>
            <Nav.Link href="/news-presse" className="link">{t("News presse")}</Nav.Link>
            <Nav.Link href="/evenement" className="link">{t("Événements")}</Nav.Link>
            <Nav.Link href="/nous-contacter" className="link contact-link  text-white">{t("Nous contacter")}</Nav.Link>
          </Nav>
        </Navbar.Collapse>

        {/* Sélecteur de langue */}
        <div className="traduction">
          <button
            className="lang-btn"
            onClick={() => handleChangeLng("fr")}
            title="Français"
          >
            <img src={fr} alt="FR" />
            <span>FR</span>
          </button>
          <button
            className="lang-btn"
            onClick={() => handleChangeLng("en")}
            title="English"
          >
            <img src={en} alt="EN" />
            <span>EN</span>
          </button>
        </div>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;
